import { render } from "./SelectedModel.vue?vue&type=template&id=11a42847"
import script from "./SelectedModel.vue?vue&type=script&lang=js"
export * from "./SelectedModel.vue?vue&type=script&lang=js"

import "./SelectedModel.vue?vue&type=style&index=0&id=11a42847&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection,QCardActions,QIcon,QTooltip});
